import { IMonthYearControl } from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  FormControlViewModelType,
  LocalizedProps,
  MonthYearFormControlViewModel,
} from '../../view-model/FormControlViewModel';
import { FormSource, FormSourceType } from '../../view-model/FormSource';

import { getValueFromArgsOrConfig } from './helpers';

const buildMonthYearControl = async (
  item: IMonthYearControl,
  localizedProps: LocalizedProps,
  args: TActionArgsValues,
  source: FormSource
): Promise<MonthYearFormControlViewModel> => ({
  isFirstDay: item.isFirstDay,
  columns: item.columns,
  disabled: item.disabled,
  required: item.required,
  readonly: item.readonly || source.type === FormSourceType.REVIEW,
  invalid: item.invalid,
  errorMessage: item.errorMessage,
  value: getValueFromArgsOrConfig<Date | null>(item, args, source, null),
  hasValue: true,
  hasHistory: false,
  name: item.name,
  noLabel: item.noLabel,
  labelWidth: item.labelWidth,
  storeValue: item.storeValue,
  type: FormControlViewModelType.MONTH_YEAR,
  visible: item.visible,
  ...localizedProps,
});

export default buildMonthYearControl;
